import { callGetApiToServer } from "../callApi";

export async function getTransactionAPI(authtoken, skip, limit, salesId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let endUrl = `v1/auth/sales/admin-sales-transactions/${salesId}/${skip}/${limit}`;

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
